import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
export const Footer = () => {
  const {
    language
  } = useLanguage();
  const {
    theme
  } = useTheme();
  const isRTL = language === 'ar';
  const currentYear = new Date().getFullYear();
  return <footer className="w-full border-t border-gray-200 dark:border-gray-800" data-id="element-2623">
      {/* Main footer content */}
      <div className="container mx-auto px-4 py-8 md:py-10" data-id="element-2624">
        <div className="flex flex-col items-center" data-id="element-2625">
          {/* Logo and brand */}
          <div className="mb-6 text-center" data-id="element-2626">
            <div className="flex items-center justify-center gap-2" data-id="element-2627">
              <h2 className="text-2xl font-bold" data-id="element-2628">
                <span className="text-black dark:text-white" data-id="element-2629">Arabic</span>
                <span className="text-primary-600 dark:text-primary-400" data-id="element-2630">
                  With
                </span>
                <span className="text-blue-500" data-id="element-2631">English</span>
              </h2>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oMRv8bhDx9fe6eD1uoaTSp/image.png" alt="Logo" className="w-8 h-8 object-contain" data-id="element-2632" />
            </div>
          </div>
          {/* Social media icons */}
          <div className="flex justify-center gap-4 mb-6" data-id="element-2633">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:opacity-90 transition-opacity" aria-label="Instagram" data-id="element-2634">
              <Instagram size={20} data-id="element-2635" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 text-white hover:opacity-90 transition-opacity" aria-label="LinkedIn" data-id="element-2636">
              <Linkedin size={20} data-id="element-2637" />
            </a>
          </div>
          {/* Copyright */}
          <div className="text-center mb-6 text-gray-600 dark:text-gray-400 text-sm" data-id="element-2638">
            {isRTL ? <p data-id="element-2639">جميع الحقوق محفوظة. Arabic With English {currentYear} ©</p> : <p data-id="element-2640">© {currentYear} Arabic With English. All rights reserved.</p>}
          </div>
        </div>
      </div>
      {/* Footer bottom - links and secondary copyright */}
      <div className="w-full border-t border-gray-200 dark:border-gray-800" data-id="element-2641">
        <div className="container mx-auto px-4 py-4" data-id="element-2642">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-2643">
            {/* Navigation links */}
            <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-8 text-sm text-gray-600 dark:text-gray-400" data-id="element-2644">
              <Link to="/contact" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-2645">
                {isRTL ? 'اتصل بنا' : 'Contact Us'}
              </Link>
              <Link to="/terms" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-2646">
                {isRTL ? 'الشروط' : 'Terms'}
              </Link>
              <Link to="/privacy" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-2647">
                {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </Link>
            </div>
            {/* Secondary copyright */}
            <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2648">
              {isRTL ? <p data-id="element-2649">
                  © Abdalrahman Sarhan {currentYear}{' '}
                  <span className="font-bold" data-id="element-2650">ArabicWithEnglish</span>
                </p> : <p data-id="element-2651">
                  <span className="font-bold" data-id="element-2652">ArabicWithEnglish</span> ©{' '}
                  {currentYear} Abdalrahman Sarhan
                </p>}
            </div>
          </div>
        </div>
      </div>
    </footer>;
};